import type { FC } from "react"

import type { TDiagnosticSummaryEntityProps as TEntityProps } from "./diagnostic-summary.ui.types"

async function diagnosticSummaryEntityLoader(): Promise<{ default: FC<TEntityProps> }> {
    return await import("./diagnostic-summary.entity").then(
        ({ DiagnosticResultsEntity: E }): { default: FC<TEntityProps> } => ({ default: E })
    )
}

export { diagnosticSummaryEntityLoader }
